// const viewportEl = document.querySelector('meta[name="viewport"]');
// dpr = dpr >= 3 ? 3 : (dpr >= 2 ? 2 : 1);
// const dpr = window.devicePixelRatio || 1;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 获取设备尺寸信息
 * @param size
 * @param deviceWidth
 */
function getDeviceSize(size, deviceWidth) {
    return parseInt(size, 10) * deviceWidth / 750 + 'px';
}
/**
 * 获取单个Style内容
 * @param style
 * @param deviceWidth
 */
function getSimpleStyle(style, deviceWidth) {
    var formatStyle = {};
    Object.keys(style).map(function (v) {
        formatStyle[v] = String(style[v]).indexOf('px') > 0 ? getDeviceSize(style[v], deviceWidth) : style[v];
    });
    return formatStyle;
}
/**
 * 获取整体Style内容
 * @param style
 */
export function getDeviceStyle(style) {
    if (!style)
        return {};
    // const deviceWidth = window.self.document.documentElement.getBoundingClientRect().width || window.self.innerWidth;
    var deviceWidth = window.self.document.documentElement.getBoundingClientRect().width || window.self.innerWidth;
    deviceWidth = deviceWidth > 750 ? 375 : deviceWidth;
    var formatStyleObj = {};
    Object.keys(style).map(function (svo) {
        formatStyleObj[svo] = getSimpleStyle(style[svo], deviceWidth);
        return svo;
    });
    return formatStyleObj;
}
/**
 * merge 多层级 style
 * @param style
 */
export function mergeAllStyle(mergeStyle, style) {
    if (!mergeStyle || !style)
        return {};
    var formatStyleObj = {};
    Object.keys(mergeStyle).map(function (svo) {
        formatStyleObj[svo] = __assign(__assign({}, (mergeStyle[svo] || {})), (style[svo] || {}));
        return svo;
    });
    return formatStyleObj;
}
